
































































import Vue from 'vue';
import key from '@/libs/filters/key'
import { Component, Prop } from 'vue-property-decorator';
import { TBranchForm } from '@/types/views/school.d.ts'
@Component({})
export default class Search extends Vue {
    @Prop({
        type: Function,
        default() {
            return function() {}
        }
    })
    handleOptions!: Function
    @Prop({
        type: Function,
        default() {
            return function() {}
        }
    })
    getData!: Function
    key: any = key
    form: TBranchForm = {
        name: '',
        cuStomerType: '',
        contactName: '',
        contactPhone: '',
        minTotalCoursePackage: '',
        minSurplusCoursePackage: '',
        maxSurplusCoursePackage: ''
    }

     search() {
      const f = this.form,
        opts = {
          ...f
        };
      this.handleOptions(opts);
      this.getData();
    }
    reset() {
      let change = false;
      for (let key in this.form) {
        if ((this.form as any)[key] !== '') {
          change = true;
          break;
        }
      }
      if (!change) return;
      this.form = {
         name: '',
          cuStomerType: '',
          contactName: '',
          contactPhone: '',
          minTotalCoursePackage: '',
          minSurplusCoursePackage: '',
          maxSurplusCoursePackage: ''
      };
      this.search();
    }
}
